<template>
  <v-card elevation="1" style="width: 100%" flat tile>
    <v-list-item>
      <v-row>
        <v-col cols="7" class="align-center d-flex">
          <h4 class="mx-2 subtitle-2">{{ title }}</h4>
        </v-col>
        <v-col cols="5">
          <v-text-field
            @keydown.enter="handleFilter"
            @click:append="handleFilter"
            min="0"
            type="number"
            hide-details
            class="white"
            dense
            v-model="value"
            :value="hasFilterActive ? value : ''"
            append-icon="mdi-arrow-right-circle-outline"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-list-item>
    <v-divider />
  </v-card>
</template>

<script>
export default {
  props: {
    field: String,
    title: String,
    breadcrumbTitle: Boolean,
    type: String
  },
  data: () => ({
    value: "",
  }),
  computed: {
    hasFilterActive() {
      let filter = this.$store.state.filters.find(
        (f) => f.field === this.field
      );
      if (!filter) {
        // eslint-disable-next-line
        this.value = "";
      }
      return !!filter;
    },
  },
  methods: {
    // debounceMethod (ms, call) {
    //   // cancel pending call
    //   clearTimeout(this._timerId);

    //   this._timerId = setTimeout(call, ms);
    // },
    handleFilter() {
      this.$store.commit("removeFilter", { id: this.field });

      if (this.value !== "") { 
        this.$store.commit("setFilter", {
          field: this.field,
          value: this.value,
          breadcrumbs: this.breadcrumbTitle,
          title: this.title,
          type: this.type,
          id: this.field
        });
      }
    }
  },
  created(){
    let filter = this.$store.state.filters.find(filter => filter.field === this.field);
    if(filter) this.value = filter.value;
  }
};
</script>

<style lang="scss">
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
